import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { deletePaymentMethod, fetchPaymentMethods } from "./api";
import { initialState } from "./paymentCards.types";



export const loadCards = createAsyncThunk(
    "payments/loadCards",
    async (token: string, { rejectWithValue }) => {
        try {
            return await fetchPaymentMethods(token);
        } catch (error) {
            return rejectWithValue(String(error));
        }
    }
);

export const deleteCard = createAsyncThunk(
    "payments/deleteCards",
    async ({ token, id }: { token: string, id: string }, { rejectWithValue }) => {
        try {
            return await deletePaymentMethod(token, id);
        } catch (error) {
            return rejectWithValue(String(error));
        }
    }
);

export const paymentsSlice = createSlice({
    name: "payments",
    initialState,
    reducers: {
        selectCard: (
            state,
            action: PayloadAction<string>
        ) => {
            state.selectedCardId = action.payload;
        },

        setShowAddCards: state => {
            state.showAddCard = true;
        },

        hideShowAddCards: state => {
            state.showAddCard = false;
        },

        clearPaymentErrors: state => {
            state.errors = [];
        },
    },

    extraReducers: builder => {
        builder
            .addCase(loadCards.pending, state => {
                state.loading = true;
                state.errors = [];
                state.showAddCard = false;

            })
            .addCase(loadCards.fulfilled, (state, action) => {
                state.loading = false;
                state.cards = action.payload;

                if (action.payload.length === 0) {
                    state.showAddCard = true
                }

                if (
                    !state.selectedCardId &&
                    action.payload.length > 0
                ) {
                    state.selectedCardId = action.payload[0].id;
                }
            })

            .addCase(loadCards.rejected, (state, action) => {
                state.loading = false;
                state.showAddCard = true;

                state.errors.push(
                    action.payload as string
                );
            })

            .addCase(deleteCard.pending, state => {
                state.loading = true;
                state.errors = [];
                state.showAddCard = false;

            })

            .addCase(deleteCard.fulfilled, (state, action) => {
                state.loading = false;
                state.cards = action.payload;

                if (action.payload.length === 0) {
                    state.showAddCard = true
                }

                if (
                    !state.selectedCardId &&
                    action.payload.length > 0
                ) {
                    state.selectedCardId = action.payload[0].id;
                }

            })

            .addCase(deleteCard.rejected, (state, action) => {
                state.loading = false;
                state.showAddCard = true;

                state.errors.push(
                    action.payload as string
                );
            })




    },
});

export const {
    selectCard,
    clearPaymentErrors,
    setShowAddCards,
    hideShowAddCards,
} = paymentsSlice.actions;



export default paymentsSlice.reducer;


